import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Dashboard from "@/pages/Dashboard";
import { Toaster } from "@/components/ui/sonner";
import { SettingsProvider } from "@/lib/settings";

function App() {
  return (
    <SettingsProvider>
      <div className="App bg-grain min-h-screen">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Dashboard />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          theme="dark"
          position="top-right"
          toastOptions={{
            style: {
              background: "hsl(0 0% 8%)",
              color: "hsl(0 0% 96%)",
              border: "1px solid hsl(0 0% 16%)",
            },
          }}
        />
      </div>
    </SettingsProvider>
  );
}

export default App;
